var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTtFull({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "66 460 480 80",
    enableBackground: "new 66 460 480 80",
    xmlSpace: "preserve",
    width: "313px",
    height: "313px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    stroke: "#000",
    strokeWidth: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "158.4,386.7 152.3,386.7 152.3,382.5 169.3,382.5 169.3,386.7 163.2,386.7 163.2,404.1  158.4,404.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M171.7,382.5h8.4c4.4,0,8.1,1.5,8.1,6.6c0,3-1.6,5.4-4.7,5.9l5.5,9.1h-5.7l-4.5-8.6h-2.4v8.6h-4.8V382.5z  M176.5,391.5h2.8c1.7,0,4-0.1,4-2.4c0-2.2-1.9-2.5-3.7-2.5h-3.1V391.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M198.6,382.5h3.9l9.4,21.6h-5.4l-1.9-4.6h-8.4l-1.8,4.6h-5.2L198.6,382.5z M200.4,388.8l-2.6,6.7h5.3 L200.4,388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M214.1,382.5h7.1c7,0,12.8,3,12.8,10.8c0,7-5.7,10.7-12.1,10.7h-7.8L214.1,382.5L214.1,382.5z M218.9,399.7 h2.5c4.4,0,7.7-1.7,7.7-6.6c0-4.2-3.4-6.2-7.4-6.2h-2.8V399.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.2,
    y: 382.5,
    fill: "#004964",
    width: 4.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "246.3,382.5 252.7,382.5 261.9,397.5 262,397.5 262,382.5 266.7,382.5 266.7,404.1 260.5,404.1  251.1,388.7 251,388.7 251,404.1 246.3,404.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M290.7,402.6c-2.8,1.5-5.9,2.1-9.1,2.1c-6.7,0-11.6-4.4-11.6-11.3c0-6.9,4.9-11.3,11.6-11.3 c3.4,0,6.4,0.8,8.6,2.8l-3.4,3.7c-1.3-1.3-2.8-2-5.2-2c-4,0-6.7,2.9-6.7,7c0,4,2.7,7,6.7,7c2.1,0,3.6-0.6,4.5-1.1v-3.5h-3.9v-4.4 h8.4L290.7,402.6L290.7,402.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "308,386.7 301.9,386.7 301.9,382.5 319,382.5 319,386.7 312.8,386.7 312.8,404.1 308,404.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "321.5,382.5 336.2,382.5 336.2,386.9 326.3,386.9 326.3,390.9 335.7,390.9 335.7,395.3  326.3,395.3 326.3,399.7 336.8,399.7 336.8,404.1 321.5,404.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M354.7,388.1c-0.9-1.1-2.3-1.8-4.1-1.8c-3.6,0-6.2,2.9-6.2,7c0,4,2.7,7,6.1,7c1.9,0,3.5-0.9,4.5-2.3l4,3 c-1.8,2.6-4.9,3.8-7.8,3.8c-6.7,0-11.7-4.4-11.7-11.3c0-6.9,4.9-11.3,11.7-11.3c2.4,0,5.5,0.8,7.3,3.2L354.7,388.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "361.5,382.5 366.2,382.5 366.2,390.6 375.5,390.6 375.5,382.5 380.2,382.5 380.2,404.1  375.5,404.1 375.5,394.8 366.2,394.8 366.2,404.1 361.5,404.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "384.6,382.5 391.1,382.5 400.2,397.5 400.3,397.5 400.3,382.5 405.1,382.5 405.1,404.1  398.8,404.1 389.4,388.7 389.4,388.7 389.4,404.1 384.6,404.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M419.9,382c6.7,0,11.6,4.4,11.6,11.3c0,6.9-4.9,11.3-11.6,11.3c-6.7,0-11.7-4.4-11.7-11.3 C408.3,386.4,413.2,382,419.9,382 M419.9,400.3c4,0,6.7-2.9,6.7-7s-2.7-7-6.7-7s-6.7,2.9-6.7,7S415.9,400.3,419.9,400.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "435,382.5 439.8,382.5 439.8,399.7 448.6,399.7 448.6,404.1 435,404.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M461.7,382c6.7,0,11.6,4.4,11.6,11.3c0,6.9-4.9,11.3-11.6,11.3c-6.7,0-11.7-4.4-11.7-11.3 C450,386.4,455,382,461.7,382 M461.7,400.3c4,0,6.7-2.9,6.7-7s-2.7-7-6.7-7s-6.7,2.9-6.7,7S457.6,400.3,461.7,400.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M496.1,402.6c-2.8,1.5-5.9,2.1-9.1,2.1c-6.7,0-11.7-4.4-11.7-11.3c0-6.9,4.9-11.3,11.7-11.3 c3.4,0,6.4,0.8,8.6,2.8l-3.4,3.7c-1.3-1.3-2.8-2-5.2-2c-4.1,0-6.7,2.9-6.7,7c0,4,2.7,7,6.7,7c2.1,0,3.6-0.6,4.5-1.1v-3.5h-3.9v-4.4 h8.4V402.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.2,
    y: 382.5,
    fill: "#004964",
    width: 4.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "509.5,382.5 524.2,382.5 524.2,386.9 514.2,386.9 514.2,390.9 523.6,390.9 523.6,395.3  514.2,395.3 514.2,399.7 524.7,399.7 524.7,404.1 509.5,404.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004964",
    d: "M539.2,387.8c-0.8-1-2.3-1.4-3.4-1.4c-1.3,0-3.2,0.6-3.2,2.2c0,3.9,9.9,1.4,9.9,9c0,4.8-3.9,7.1-8.3,7.1 c-2.8,0-5.2-0.8-7.2-2.7l3.4-3.7c1,1.3,2.6,2,4.1,2c1.6,0,3.3-0.7,3.3-2.3c0-4-10.1-1.8-10.1-9c0-4.6,4-7,8.2-7 c2.4,0,4.8,0.6,6.6,2.3L539.2,387.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#91D5E4",
    points: "110.5,366.3 105.1,360.9 72.8,393.2 78.2,398.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004964",
    points: "88.9,409.3 105.1,425.5 111.9,418.7 95.7,402.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0095D6",
    points: "122.4,408.1 137.3,393.2 113.1,369 98.2,383.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#38929A",
    points: "95.7,386.4 80.8,401.3 86.2,406.7 95.6,397.3 114.4,416.1 119.9,410.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTtFull);
export default __webpack_public_path__ + "static/media/logo-tt-full.8310e905d311daebca20ea4e41842cca.svg";
export { ForwardRef as ReactComponent };